<template>
   <v-card>
      <v-card-title>{{ paymentTitle }}</v-card-title>
      <v-card-subtitle></v-card-subtitle>
      <v-card-text>
         <p v-if="iscorporateupgrade">
            Your Corporate upgrade application has been approved. You can proceed with the payment process.
         </p>
         <p v-else-if="isgraduateupgrade">
            Your Student to Graduate upgrade has been approved by the Secretariat. Your membership is now pending payment.
            Please complete the payment process to activate your Graduate membership.
         </p>
         <p v-else>
            Your application has been approved. You can proceed with the payment process.
         </p>
         <div>
            <h5>{{ paymentStatusTitle }}</h5>
            <b>Date Submitted:</b> {{ (memberinfo) ? formatdate(memberinfo.dateapplied) : '' }}<br>
            <b>Date Approved:</b> {{ (memberinfo) ? formatdate(memberinfo.dateapproved) : '' }}<br>
            <b>Status:</b> {{ (memberinfo) ? formatstatus(memberinfo.memberstatus) : '' }}<br>
         </div>
      </v-card-text>
      <v-card-text>
         <table-payment-s-f ref="tblpay" v-on:PaymentCompleted="onPaymentCompleted"></table-payment-s-f>
      </v-card-text>
   </v-card>
</template>

<script>
const axios = require('axios')
import TablePaymentSF from '../Tables/TablePaymentSF.vue'


export default {
   name: 'PanelPayment',
   props: {},
   components: {
      TablePaymentSF,
   },
   data: () => ({
      user: Object,
      memberinfo: null,
   }),
   watch: {
      memberinfo: function(newval, oldval) {
         if (newval) {
            if (this.$refs.tblpay) {
               this.$refs.tblpay.setuserid(this.user.id)
            }
         }
      }
   },
   methods: {
      formatdate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY h:mm:ss A')
      },

      formatstatus(e) {
         if (e === 0) {
            return 'Applying'
         }
         if (e === 1) {
            return 'Pending Approval'
         }
         if (e === 2) {
            return 'Pending Payment'
         }
      },

      onPaymentCompleted() {
         this.loadmemberinfo()
      },

      loadmemberinfo() {
         this.$nextTick( function () {
            if (this.user.usertype === 'members') {
               var url = '/member/info/' + this.user.id
               axios.get(url)
               .then((resp) => {
                  if (resp.data) {
                     var rtn = resp.data
                     if (rtn.status === 'OK') {
                        this.memberinfo = rtn.data
                     } else {
                        console.log(rtn.status + ': ' + rtn.error)
                     }
                  }
               })
            }
         })
      },
   },
   mounted: function () {
      this.user = this.$page.user
      this.loadmemberinfo()
   },

   computed: {
      iscorporateupgrade() {
         return this.memberinfo && parseInt(this.memberinfo.applcorpstatus || 0) > 0
      },
      isgraduateupgrade() {
         return this.memberinfo
            && this.memberinfo.membertype === 'GRA'
            && parseInt(this.memberinfo.memberstatus || 0) === 2
            && parseInt(this.memberinfo.applgradstatus || 0) === 2
      },
      paymentTitle() {
         if (this.iscorporateupgrade) return 'Corporate Upgrade Payment'
         if (this.isgraduateupgrade) return 'Graduate Upgrade Pending Payment'
         return 'Membership Application Payment'
      },
      paymentStatusTitle() {
         if (this.iscorporateupgrade) return 'Corporate Upgrade Status'
         if (this.isgraduateupgrade) return 'Graduate Upgrade Status'
         return 'Membership Application Status'
      },
   },
}
</script>
